// extracted by mini-css-extract-plugin
export default {"root":"MenuDrawer_root__jCyWM","button":"MenuDrawer_button__-2pDM","icon":"MenuDrawer_icon__bNr9l"};